export function getApi () {
  const apiGateway = process.env.API_GATEWAY
  function c (path) {
    return apiGateway + path
  }
  return {
    auth: c('/auth'),
    payment: c('/payment')
  }
}

export const FACEBOOK_APP_ID = process.env.NODE_ENV === 'production'
  ? '609154359261757'
  : '574195459690327'

export const GG_ANALYTIC_ID = process.env.NODE_ENV === 'production'
  ? 'UA-125809491-3'
  : 'UA-125809491-4'
